/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    code: "code",
    a: "a",
    h3: "h3",
    ol: "ol",
    li: "li",
    strong: "strong",
    pre: "pre",
    ul: "ul"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Description"
    }), "\n", _jsxs(_components.p, {
      children: ["The GlobalStatus is a complex component meant for displaying global Application notifications or a summary of a form ( displaying form errors, messages etc. ).\nBy default, the ", _jsx(_components.code, {
        children: "GlobalStatus"
      }), " is automatically connected together with the ", _jsx(_components.a, {
        href: "/uilib/components/form-status",
        children: "FormStatus"
      }), " component. This means, that every form component showing a status, will send the status message along to the ", _jsx(_components.code, {
        children: "GlobalStatus"
      }), "."]
    }), "\n", _jsx(_components.h3, {
      children: "FormStatus default behavior"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Once a ", _jsx(_components.strong, {
          children: "FormStatus"
        }), " is shown, the ", _jsx(_components.code, {
          children: "main"
        }), " ", _jsx(_components.strong, {
          children: "GlobalStatus"
        }), " will show up."]
      }), "\n", _jsxs(_components.li, {
        children: ["The page will scroll (if needed) to the dedicated ", _jsx(_components.strong, {
          children: "GlobalStatus"
        }), "."]
      }), "\n", _jsx(_components.li, {
        children: "Form components will send along both the status text and its label to show a good and accessible summary."
      }), "\n", _jsxs(_components.li, {
        children: ["Screen reader uses will automatically hear the whole content of the ", _jsx(_components.code, {
          children: "GlobalStatus"
        }), " once it shows up."]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Several Global statuses"
    }), "\n", _jsxs(_components.p, {
      children: ["Normally, you only want to have ", _jsx(_components.strong, {
        children: "one"
      }), " ", _jsx(_components.code, {
        children: "GlobalStatus"
      }), " inside your application. But you can have several in parallel. But make sure you give every other a new ID:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-jsx",
        children: "<GlobalStatus id=\"other-global-status\" />\n"
      })
    }), "\n", _jsx(_components.h3, {
      children: "Where to put it"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["The ", _jsx(_components.code, {
          children: "GlobalStatus"
        }), " component should be positioned right under the header. By default, it uses ", _jsx(_components.code, {
          children: "main"
        }), " as the ID."]
      }), "\n", _jsxs(_components.li, {
        children: ["Or as a secondary summary of errors in a submit form. Keep in mind, by default, form components like ", _jsx(_components.a, {
          href: "/uilib/components/input",
          children: "Input"
        }), " are using the ID ", _jsx(_components.code, {
          children: "main"
        }), ". To make sure the build in ", _jsx(_components.a, {
          href: "/uilib/components/form-status",
          children: "FormStatus"
        }), " is sending along the message to another ", _jsx(_components.code, {
          children: "GlobalStatus"
        }), ", you have to set the ", _jsx(_components.code, {
          children: "global_status_id"
        }), ", like:"]
      }), "\n"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-jsx",
        children: "<GlobalStatus id=\"other-global-status\" />\n...\n<Input global_status_id=\"other-global-status\" ... />\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["But you can also make use of the ", _jsx(_components.a, {
        href: "/uilib/components/form-set",
        children: "FormSet"
      }), " or ", _jsx(_components.a, {
        href: "/uilib/components/form-row",
        children: "FormRow"
      }), " which will send along the ", _jsx(_components.code, {
        children: "global_status_id"
      }), " the underlying/wrapped components, like:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-jsx",
        children: "<GlobalStatus id=\"other-global-status\" />\n...\n<FormSet global_status_id=\"other-global-status\">\n  <Input status=\"Message\" />\n  ...\n</FormSet>\n"
      })
    }), "\n", _jsx(_components.h3, {
      children: "Manually updates"
    }), "\n", _jsxs(_components.p, {
      children: ["Besides the automated connection between the error states of form components (", _jsx(_components.a, {
        href: "/uilib/components/form-status",
        children: "FormStatus"
      }), "), you can update messages from everywhere in your application at any time:"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "NB:"
      }), " The GlobalStatus will ", _jsx(_components.code, {
        children: "autoclose"
      }), " by default, once all messages are removed."]
    }), "\n", _jsx(_components.h3, {
      children: "JavaScript (interceptor situation)"
    }), "\n", _jsx(_components.p, {
      children: "You can access and manipulate an existing GlobalStatus from outside of the React render tree."
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "Given you have already defined a GlobalStatus in JSX:"
      }), "\n"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-jsx",
        children: "<GlobalStatus id=\"other-global-status\" />\n"
      })
    }), "\n", _jsxs(_components.ol, {
      start: "2",
      children: ["\n", _jsx(_components.li, {
        children: "Then you can control it from within a JavaScript context whenever you need to:"
      }), "\n"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        children: "import { GlobalStatus } from '@dnb/eufemia/components'\n\n// 1. Update / extend the the status like so:\nconst statusOne = GlobalStatus.create({\n  id: 'other-global-status', // or main\n  status_id: 'custom-id-1',\n  text: 'New Text',\n  item: 'Item from status #1',\n})\n\n// 2. and removes \"custom-id-1\" again if needed\nstatusOne.update({\n  text: 'Updated Text',\n})\n\n// 3. and removes \"custom-id-1\" again if needed\nstatusOne.remove()\n"
      })
    }), "\n", _jsx(_components.h3, {
      children: "JSX"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-jsx",
        children: "import { GlobalStatus } from '@dnb/eufemia/components'\n\n// 1. Place it under the header bar\n<GlobalStatus text=\"Optional default text\" />\n\n// 2. later on, you can show a message\n<GlobalStatus.Add\n  status_id=\"custom-id-1\"\n  title=\"New title\"\n  text=\"First long info text ...\"\n  item=\"Item from status #1\"\n/>\n\n// 3. and remove it again\n<GlobalStatus.Remove status_id=\"custom-id-1\" />\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["If you need an additional ", _jsx(_components.code, {
        children: "GlobalStatus"
      }), ", define a custom ID (custom-status):"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-jsx",
        children: "import { GlobalStatus } from '@dnb/eufemia/components'\n\n// 1. Place it somewhere in your application\n<GlobalStatus id=\"custom-status\" />\n\n// 2. later on, you can show a message\n<GlobalStatus.Add\n  id=\"custom-status\"\n  status_id=\"custom-id-1\"\n  title=\"New title\"\n  text=\"First long info text ...\"\n  item=\"Item from status #1\"\n/>\n\n// 3. and remove it again\n<GlobalStatus.Remove id=\"custom-status\" status_id=\"custom-id-1\" />\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
